import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import Button from 'modules/_shared/components/Buttons';

type BeneficiarySocietyActionButtonsProps = {
  hasTenderOffers: boolean;
  hasIncentivesMarketEnabled: boolean;
  isAcceptButtonVisible: boolean;
  onSeeOffers: () => void;
  onOpenIncentivesMarket: () => void;
  onGoToPlansTab: () => void;
};

const BeneficiarySocietyActionButtons: FC<
  BeneficiarySocietyActionButtonsProps
> = ({
  hasTenderOffers,
  hasIncentivesMarketEnabled,
  isAcceptButtonVisible,
  onSeeOffers,
  onOpenIncentivesMarket,
  onGoToPlansTab,
}) => {
  const { t } = useTranslate();

  return (
    <>
      {hasTenderOffers && !hasIncentivesMarketEnabled && (
        <div className="card-inner card-inner-sm text-center">
          <Button text={t('SeeOffers')} onClick={onSeeOffers} />
        </div>
      )}

      {hasIncentivesMarketEnabled && (
        <div className="card-inner card-inner-sm text-center">
          <Button
            variant="info"
            text={t('IncentivesMarket')}
            onClick={onOpenIncentivesMarket}
          />
        </div>
      )}

      {isAcceptButtonVisible && (
        <div className="card-inner card-inner-sm">
          <ul className="btn-toolbar justify-center">
            <Button
              variant="success"
              icon="check-round-cut"
              className="m-1"
              text={t('LinkToPlansTab')}
              onClick={onGoToPlansTab}
            />
          </ul>
        </div>
      )}
    </>
  );
};

export default BeneficiarySocietyActionButtons;
